/**
 * Generates props for the MapComponent based on current state and handlers
 * @param {Object} options - Options for prop generation
 * @param {Array} options.addresses - All addresses
 * @param {Array} options.filteredAddresses - Filtered addresses to display
 * @param {Object} options.mapState - Map state from useMapState hook
 * @param {boolean} options.showAddresses - Whether to show address cards
 * @param {Function} options.setShowAddresses - Function to toggle address cards
 * @param {Object} options.addressCardsRef - Ref for address cards
 * @param {Object} options.lotsAvailableByLocationId - Available lots by location
 * @param {Object} options.nextAvailableDates - Next available date by location ID
 * @param {Function} options.handleAddressClick - Function to handle address click
 * @param {Function} options.handleShowAddressesClick - Function to handle show addresses click
 * @param {Function} options.handleBookNowClick - Function to handle book now click
 * @param {string|null} options.selectedAddress - Currently selected address label
 * @param {string} options.selectedLocationId - Currently selected location ID
 * @param {string|null} options.activeStateFilter - Currently selected state filter chip
 * @param {React.ReactNode|null} options.addressListTopContent - Optional content rendered above address cards when map list is visible
 * @param {boolean} options.forceAddressListVisible - Forces the address list visible without using the toggle state
 * @param {boolean} options.hideAddressToggle - Hides the show/hide address toggle button
 * @returns {Object} - Props for the MapComponent
 */
export const generateMapComponentProps = ({
  addresses,
  filteredAddresses,
  mapState,
  showAddresses,
  setShowAddresses,
  addressCardsRef,
  lotsAvailableByLocationId,
  nextAvailableDates = {},
  handleAddressClick,
  handleShowAddressesClick,
  handleBookNowClick,
  selectedAddress = null,
  selectedLocationId = null,
  activeStateFilter = null,
  addressListTopContent = null,
  forceAddressListVisible = false,
  hideAddressToggle = false,
}) => {
  return {
    addresses,
    filteredAddresses,
    center: mapState.mapCenter,
    zoom: mapState.mapZoom,
    showAddresses,
    setShowAddresses,
    handleShowAddressesClick,
    handleAddressClick,
    handleBookNowClick,
    addressCardsRef,
    lotsAvailableByLocationId,
    nextAvailableDates,
    selectedAddressLabel: selectedAddress,
    selectedLocationId,
    activeStateFilter,
    addressListTopContent,
    forceAddressListVisible,
    hideAddressToggle,
  };
};

export default {
  generateMapComponentProps
}; 
